import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PrimaryButton from "../../../common/buttons/PrimaryButton";
import { UPDATE_EVENT } from "../../../redux/constants/eventConstants";
import { patchAuthenticatedRequest } from "../../../utils/API/api.ts";
import TopModal from "../../../common/topModal/TopModal";
import AddSession from "./AddSession";
import DefaultProfilePicture from "../../../common/defaultProfilePicture/DefaultProfilePicture";
import { getSingleEvent } from "../../../redux/actions/eventActions";
import { useMatch } from "react-router-dom";
import { showToast } from "../../../redux/actions/toastActions";

function Schedule() {
  const [open, setOpen] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [singleSchedule, setSingleSchedule] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const event = useSelector((state) => state.eventData);
  const dispatch = useDispatch();
  const [deletSeesion, setDeleteSession] = useState("");
  const eventsId = useMatch("events/:eventId/*");

  useEffect(() => {
    if (eventsId?.params?.eventId) {
      dispatch(getSingleEvent({ eventId: eventsId.params.eventId }));
    }
  }, [eventsId?.params?.eventId, dispatch]);

  useEffect(() => {
    const schedule = event.schedule;

    let allSessions = [];
    if (schedule?.length > 0) {
      schedule.forEach((day) => {
        allSessions = [...allSessions, ...day.sessions];
      });

      setSchedule(allSessions);
    }
  }, [event]);

  return (
    <>
      <div className="w-full md:w-[422px] md:ml-[0px] md:mt-[0px]">
        <TopModal message="Are you sure you want to delete?" />
        <div className="py-0">
          <div className="font-[600] w-[335px] md:w-[422px] pt-0 text-black md:flex items-center justify-between fixed bg-white z-10 min-h-[82px] ">
            <p className="text-[21px] mt-1">Schedule</p>
            {schedule?.length > 0 ? (
              <div className="w-[335px] md:w-[150px]">
                <PrimaryButton
                  btnText={"Add Session"}
                  onClick={() => {
                    setOpen(true);
                    setIsEdit(false);
                  }}
                  style={{ height: "35px" }}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="mt-2 mb-[30px] overflow-y-auto mx-auto w-[335px] md:w-[422px] scrollbar pt-[75px] absolute pb-[50px]">
            {schedule?.length > 0 ? (
              schedule
                .sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
                .map((session, index) => (
                  <div
                    key={index}
                    className={`grid ${
                      session.onlineSessionUrl
                        ? `grid-rows-[1fr_${
                            session?.sessionDescription.length > 60
                              ? "42px"
                              : "20px"
                          }_50px]`
                        : `grid-rows-[1fr_${
                            session?.sessionDescription.length > 60
                              ? "42px"
                              : "20px"
                          }]`
                    }w-[95%] relative left-[0px] border-b-[1px] border-b-[#d0d0d0] py-[13px]`}
                  >
                    <div className="">
                      <div className="grid grid-cols-[70px_1fr_30px_30px] ">
                        <div className="text-[13.4px] font-semibold py-1">
                          {moment(session?.startTime).format("LT")}
                        </div>
                        <div className="text-[13.4px] font-semibold py-1">
                          {/* {session._id} */}
                          {session?.sessionName}
                        </div>
                        {deletSeesion === session._id ? (
                          <div className="flex">
                            <img
                              src="/svgs/done.svg"
                              alt="done"
                              className="w-6 h-6 cursor-pointer mr-3"
                              onClick={async () => {
                                const newSchedule =
                                  event.schedule[0].sessions.filter(
                                    (ele, index) => ele._id !== session._id
                                  );
                                let scheduleCopy = [];

                                scheduleCopy[0] = {
                                  day: "1",
                                  sessions: newSchedule,
                                };
                                const updatedEvent =
                                  await patchAuthenticatedRequest(
                                    `/event/${event._id}`,
                                    {
                                      schedule: scheduleCopy,
                                    }
                                  );

                                const updatedSchedule =
                                  updatedEvent.data.savedEventConfig.schedule;
                                let allSessions = [];
                                updatedSchedule.forEach((day) => {
                                  allSessions = [
                                    ...allSessions,
                                    ...day.sessions,
                                  ];
                                });

                                setSchedule(allSessions);

                                dispatch({
                                  type: UPDATE_EVENT,
                                  payload: {
                                    schedule: updatedSchedule,
                                  },
                                });
                                setDeleteSession("");
                                dispatch(
                                  showToast({
                                    message: "Session Deleted",
                                    category: "danger",
                                  })
                                );
                              }}
                            />
                            <img
                              src="/svgs/Cross.svg"
                              alt="delete"
                              className="w-6 h-6 cursor-pointer"
                              onClick={() => setDeleteSession("")}
                            />
                          </div>
                        ) : (
                          <>
                            <img
                              src="/svgs/Edit.svg"
                              alt="edit"
                              className="w-6 h-6 cursor-pointer mr-3"
                              onClick={() => {
                                setOpen(true);
                                setIsEdit(true);
                                setSingleSchedule({
                                  _id: session._id,
                                  sessionName: session.sessionName,
                                  sessionDescription:
                                    session.sessionDescription,
                                  venueName:
                                    session?.venueName && session.venueName,
                                  sessionTags: session.sessionTags,
                                  startTime:
                                    moment
                                      .utc(session.startTime)
                                      .local()
                                      .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z",
                                  speakers: session.speakers,
                                  sessionTime: "",
                                  onlineSessionUrl: session?.onlineSessionUrl,
                                });
                              }}
                            />
                            <img
                              src="/svgs/Delete.svg"
                              alt="delete"
                              className="w-6 h-6 cursor-pointer"
                              onClick={() => setDeleteSession(session._id)}
                            />
                          </>
                        )}
                      </div>
                      <div className="grid grid-cols-[70px_1fr_60px]">
                        <div className="text-sm font-semibold py-1 text-gray-500">
                          {new Date(session.startTime).toLocaleDateString(
                            "en-UK",
                            {
                              month: "short",
                              day: "numeric",
                            }
                          )}
                        </div>
                        <div className="text-[13px] font-medium py-1 text-gray-500">
                          {session?.sessionDescription.slice(0, 100)}...
                        </div>
                        <div className="spacer"></div>
                      </div>
                    </div>
                    <div className="flex mt-2 justify-between items-center">
                      <div className="grid grid-cols-[30px_30px_30px_30px] gap-[5px]">
                        {session.speakers.length > 0
                          ? session.speakers.map((ele) => {
                              for (let i = 0; i < event.speakers.length; i++) {
                                if (ele === event.speakers[i]._id) {
                                  if (event.speakers[i].profilePicture) {
                                    return (
                                      <img
                                        src={event.speakers[i].profilePicture}
                                        className="rounded-[60%] w-[30px] h-[30px] object-cover"
                                        key={ele}
                                        alt="profile"
                                      />
                                    );
                                  } else {
                                    return (
                                      <div className=" ">
                                        <DefaultProfilePicture
                                          firstName={
                                            event.speakers[i].firstName
                                          }
                                          lastName={event.speakers[i].lastName}
                                          style={{
                                            width: "30px",
                                            height: "30px",
                                            borderRadius: "300px",
                                            fontSize: "13px",
                                          }}
                                        />
                                      </div>
                                    );
                                  }
                                }
                              }
                            })
                          : []}
                      </div>
                      {session?.venueName ? (
                        <div className="venueName text-[13px] font-[500] text-[#aaaaaa] top-[0px] flex justify-end">
                          {session?.venueName && session.venueName}
                        </div>
                      ) : (
                        session.onlineSessionUrl && (
                          <div className=" pb-[0px]">
                            {/* <p className="spacer"></p>{" "} */}
                            <div className="flex items-center">
                              <span className="text-green-500 mr-2 text-[14px]">
                                &#9679; online
                              </span>

                              {/* <i className="fa-solid fa-wifi fa-font-solid text-green-500 font-[600]"></i> */}
                              <p
                                className="cursor-pointer grid place-items-center grid-cols-[1fr_0px] bg-gray-200 text-[#000] text-[13px] font-[500] w-[95px] h-[28px] px-[0px] rounded-sm "
                                onClick={() => {
                                  window.open(
                                    session.onlineSessionUrl,
                                    "_blank"
                                  );
                                }}
                              >
                                Join Now{" "}
                                {/* <i className="fa-solid fa-arrow-up-right-from-square"></i> */}
                              </p>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                ))
            ) : (
              <div className="grid w-full h-[250px]">
                <div>
                  <img
                    src="/svgs/nullState.svg"
                    alt=""
                    className="w-[200px] h-[200px]"
                  />
                  <p className="text-[15px] font-[500] text-[#717171]">
                    Nothing here...
                  </p>
                </div>
                <div className="w-[335px] md:w-[250px]">
                  <PrimaryButton
                    btnText={"Add Sessions"}
                    onClick={() => {
                      setOpen(true);
                      setIsEdit(false);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
          {/* <div className="w-[335px] md:w-[340px] mx-auto">
            <PrimaryButton
              btnText={"Add More Sessions"}
              onClick={() => {
                setOpen(true);
                setIsEdit(false);
              }}
            />
          </div> */}
          {/* <div className="w-[335px] md:w-[422px] mx-auto">
          <SecondaryButton
            btnText={"Upload CSV"}
            onClick={() => {
              console.log("clicked");
            }}
          />
        </div>

        <div className="w-[335px] mx-auto md:w-[422px]">
          <span className="text-primary font-normal text-sm cursor-pointer pt-5">
            Download the CSV format
          </span>
        </div> */}

          <AddSession
            open={open}
            setOpen={setOpen}
            setSchedule={setSchedule}
            schedule={schedule}
            event={event}
            singleSchedule={singleSchedule}
            setSingleSchedule={setSingleSchedule}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
          />
        </div>
      </div>
    </>
  );
}

export default Schedule;
